import React from 'react';
import { array } from 'prop-types';
import classNames from 'classnames';

import { Benefits } from '@fiverr-private/cms_ui';

const BenefitsWithRows = ({ content }) => {
    const className = classNames({
        'items-row-3': content.length % 3 === 0,
        'items-row-2': content.length % 2 === 0
    });

    return (
        <Benefits content={content} className={className}/>
    );
};

BenefitsWithRows.propTypes = {
    content: array
};

export default BenefitsWithRows;
